import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

type RevenueItem = {
  id: number;
  subscription: any;
  user: { id: number; username: string; email: string } | null;
  renewal_date: string | null;
  amount: number | string | null;
  payment_method: string | null;
  status: number | string | null;
  created_at: string;
};

interface RevenueListProps {
  data?: RevenueItem[];
  isLoading?: boolean;
}

const RevenueList = ({ data = [], isLoading = false }: RevenueListProps) => {
  const navigate = useNavigate();

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Customer Detail</TableCell>
            <TableCell>Subscription Plan</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Payment Method</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading
            ? Array.from({ length: 5 }).map((_, idx) => (
                <TableRow key={idx}>
                  <TableCell><Skeleton variant="text" width={200} /></TableCell>
                  <TableCell><Skeleton variant="text" width={140} /></TableCell>
                  <TableCell><Skeleton variant="text" width={80} /></TableCell>
                  <TableCell><Skeleton variant="text" width={180} /></TableCell>
                  <TableCell><Skeleton variant="text" width={120} /></TableCell>
                  <TableCell><Skeleton variant="text" width={80} /></TableCell>
                </TableRow>
              ))
            : (data?.length ? data : []).map((row) => (
                <TableRow hover key={row?.id}>
                  <TableCell>
                    <div
                      className="user_block click_action"
                      onClick={() => navigate("/manage-users/detail")}
                    >
                      <figure>
                        <img
                          src="/static/images/user_placeholder.png"
                          alt=""
                          width={40}
                        />
                      </figure>
                      <p>
                        <b>{row?.user?.username || row?.user?.email || "N/A"}</b>
                        <span>{row?.user?.email || ""}</span>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>{row?.subscription?.name || "-"}</TableCell>
                  <TableCell>AED {row?.amount ?? "-"}</TableCell>
                  <TableCell>
                    <div className="user_block">
                      <p>
                        <b>{row?.payment_method || "-"}</b>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>{row?.renewal_date || row?.created_at?.slice(0, 10) || "-"}</TableCell>
                  <TableCell>
                    <span className={
                      row?.status === 1 ? "status_btn c_success" : "status_btn c_danger"
                    }>
                      {row?.status === 1 ? "Paid" : "Unpaid"}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RevenueList;
